import { Controller } from "@hotwired/stimulus";
import { currencyFormatter } from "../../javascripts/utils/currencyFormatter";

interface PricingTier {
  min_users: number;
  max_users: number;
  price_per_user: number;
  discount_percentage: number;
}

export default class extends Controller {
  static targets = [
    "input",
    "maxTotalPrice",
    "perUserPrice",
    "totalPrice",
    "userCount",
  ];

  static values = {
    pricingTiers: Array,
    subscriptionPrice: Number,
  };

  declare totalPriceTargets: HTMLElement[]; // support multiple targets
  declare perUserPriceTargets: HTMLElement[]; // support multiple targets
  declare maxTotalPriceTargets: HTMLInputElement[]; // support multiple targets
  declare userCountTarget: HTMLElement;
  declare inputTarget: HTMLInputElement;
  declare pricingTiersValue: Array<PricingTier>;
  declare subscriptionPriceValue: number;
  declare tiers: {
    min_users: number;
    max_users: number;
    price_per_user: number;
  }[];

  connect() {
    this.updatePricing();
  }

  updatePricing() {
    const userCount = parseInt(this.inputTarget.value, 10);
    this.userCountTarget.textContent = String(userCount);

    const tier = this.pricingTiersValue.find(
      (t) => userCount >= t.min_users && userCount <= t.max_users
    );
    const pricePerUser = tier.price_per_user;
    const totalPrice = pricePerUser * userCount;
    const originalPrice = userCount * this.subscriptionPriceValue;

    // support multiple to be updated
    this.totalPriceTargets.forEach((el) => {
      el.textContent = currencyFormatter(totalPrice);
    });
    this.perUserPriceTargets.forEach((el) => {
      el.textContent = currencyFormatter(pricePerUser);
    });
    this.maxTotalPriceTargets.forEach((el) => {
      el.textContent = currencyFormatter(originalPrice);
    });

    // TODO: dispatch event so that the enquiry form gets the updated
    // userCount value as part of the submission
  }
}
